import React from "react"

import {FontColorType} from "../../../../highlight/font-color/font-color-plugin"
import {lexicalGetColorNumber} from "../../../../../actions/ge-color-number"
import {ColorPalette} from "../../../../../../../fields3/color-coding/color-coding"

type Props = {
    colorStyleType  : FontColorType

    className?      : any
}

export default function IconFontComponent(props: Props){

    let style = {}

    const colorNumber = lexicalGetColorNumber(props.colorStyleType)
    if (!_.isNil(colorNumber)) {
        style = {
            color           : gd.skin.colors.mainColor({
                colorNumber: colorNumber,
                corePalette: ColorPalette.CORE
            })
        }
    }

    const classes = Classes("ico editor-i5-font-color font-color-default ui5-ico-16 with-border", props.className)

    return <div className={classes} style={style}/>
}
